import React, { useCallback } from 'react'
import { useSelector } from 'react-redux'

import cx from 'classnames'

import { A, Button, H5 } from '@driftt/tide-core'
import { Icon } from '@driftt/tide-icons'

import { ConversationApi } from '../../../api'
import { getCurrentUser } from '../../../selectors'
import { getAppServices } from '../../../services/types'
import { NotificationSound } from '../../../typings/notificationPayload'
import { DesktopPushNotificationType } from '../../../typings/notifications'
import C from '../constants'

import styles from '../styles.module.css'

const TroubleshootNotificationsSection: React.FC<{ soundSetting: string }> = ({ soundSetting }) => {
  const yourEmail = useSelector<any, string | undefined>(state => getCurrentUser(state)?.email)
  const sendTestNotification = useCallback(
    () =>
      getAppServices().notifications.sendNotification({
        title: 'This is a test notification',
        body: 'Did it work?',
        // @ts-ignore
        sound: soundSetting ?? NotificationSound.DING,
        soundOn: soundSetting !== NotificationSound.NONE,
        conversationId: 0,
        type: DesktopPushNotificationType.CHAT,
        tag: 'test' + Math.random()
      }),
    [soundSetting]
  )

  const sendTestEmailNotification = useCallback(() => {
    ConversationApi.post('notifications/test/email').then()
  }, [])

  return (
    <section>
      <header>
        <H5>Troubleshoot notifications</H5>
        <A target="external" href={C.TROUBLESHOOT_NOTIFICATIONS_LINK}>
          Learn how to troubleshoot
        </A>
      </header>
      <div className={styles.row}>
        <div className={styles.iconTextContainer}>
          <Icon name="laptop-1" width={16} className={styles.troubleshootingIcon} />
          Test desktop notifications
        </div>
        <Button type="tertiary" onClick={sendTestNotification}>
          Send test
        </Button>
      </div>
      <div className={cx(styles.row, styles.noBorderBottom)}>
        <div className={styles.iconTextContainer}>
          <Icon name="email" width={16} className={styles.troubleshootingIcon} />
          <div>
            Test email notifications
            <p className={styles.subtext}>
              You&apos;ll receive all email notifications at <strong>{yourEmail}</strong>.{' '}
              <A target="external" href={C.UPDATE_EMAIL_LINK}>
                Update email
              </A>
            </p>
          </div>
        </div>
        <Button type="tertiary" onClick={sendTestEmailNotification}>
          Send test
        </Button>
      </div>
    </section>
  )
}

export default TroubleshootNotificationsSection
